export interface Book2026 {
  id: string;
  title: string;
  subtitle?: string;
  authors: string;
  isbn: string;
  coverUrl: string;
  publishYear: number;
  publishDate?: string;
  category?: string;
}

export const books2026: Book2026[] = [
  {
    id: '9786267782545',
    title: 'AIGC浪潮',
    subtitle: '人人都可以成為創作高手',
    authors: '張俊、肖亮、吳科盟 編著',
    isbn: '9786267782545',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/d382966f-ce13-4b8c-a73c-1d63fdfb19a1_compressed_9786267782545.webp',
    publishYear: 2026,
    category: '科技知識',
  },
  {
    id: '9786267782538',
    title: '博物館的中醫史',
    subtitle: '古人是這樣養生治病',
    authors: '甄雪燕 著',
    isbn: '9786267782538',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/bd50f0ea-fc41-4621-9826-4968b4cfd9d2_compressed_9786267782538.webp',
    publishYear: 2026,
    category: '人體與健康知識',
  },
  {
    id: '9786267782507',
    title: '人屬的世界',
    subtitle: '骨骼、工具與遺址中的演化證據',
    authors: '[美] 畢安祺（Carl Whiting Bishop）著；遲文成 主譯 孫建秋 譯',
    isbn: '9786267782507',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/fb1c037a-6483-423a-bd27-0778bea60795_compressed_9786267782507_3D_72dpi.webp',
    publishYear: 2026,
    category: '自然科學',
  },
  {
    id: '9786267782477',
    title: '太陽能量史',
    subtitle: '從觀測儀器到地球環境變化',
    authors: '[美] 查爾斯·格里利·艾博特 著；遲文成 主譯 郎淑華 譯',
    isbn: '9786267782477',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/4654c6f6-3744-47d8-8d71-569602362ea7_compressed_9786267782477_3D_72dpi.webp',
    publishYear: 2026,
    category: '地球與環境',
  },
  {
    id: '9786267782439',
    title: '西點軍校教條',
    subtitle: '22堂課打造將軍級自律',
    authors: '溫亞凡 著',
    isbn: '9786267782439',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/1d9e36b0-d73d-4236-b1c0-8e1f82aefe3e_compressed_9786267782439_3D_72dpi.webp',
    publishYear: 2026,
  },
  {
    id: '9786267782415',
    title: '奧格·曼狄諾的習慣革命',
    authors: '[美] 奧格·曼狄諾（Auger Mandino）著；趙雅筑 編譯',
    isbn: '9786267782415',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/0d07d1a8-71a3-4eab-86f0-eaa6fc2e4400_compressed_9786267782415_3D_72dpi.webp',
    publishYear: 2026,
  },
  {
    id: '9786267782385',
    title: '顯微鏡下的植物世界',
    subtitle: '從單細胞到多細胞，從海洋到陸地',
    authors: '吳成軍 主編',
    isbn: '9786267782385',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/acf8e6d5-8edd-4f87-8357-55dba21ed6ad_compressed_9786267782385_3D_72dpi.webp',
    publishYear: 2026,
    category: '動植物',
  },
  {
    id: '9786267782354',
    title: '顯微鏡下的生活日常',
    subtitle: '澱粉粒、結晶體、微生物',
    authors: '吳成軍 主編',
    isbn: '9786267782354',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/5e74d2ea-c209-45eb-a085-f5a5d31e6387_compressed_9786267782354_3D_72dpi.webp',
    publishYear: 2026,
    category: '生活科學',
  },
  {
    id: '9786267782316',
    title: '顯微鏡下的動物世界',
    subtitle: '外骨骼、翅與鱗、血管系統',
    authors: '吳成軍 主編',
    isbn: '9786267782316',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/cdbc7236-1da3-481b-b1c9-dcdc00b8c500_compressed_9786267782316_3D_72dpi.webp',
    publishYear: 2026,
    category: '動植物',
  },
  {
    id: '9786267782163',
    title: '風暴中心的追風者',
    subtitle: '攝影與科學交會的真實現場',
    authors: '蘇鏑珂 著',
    isbn: '9786267782163',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/91c1eead-e7f2-4eba-83cc-cc01a5e262b2_compressed_9786267782163_3D_72dpi.webp',
    publishYear: 2026,
    category: '地球與環境',
  },
  {
    id: '9786267782286',
    title: '顯微鏡下的細胞世界',
    subtitle: '探索微觀星球',
    authors: '吳成軍 主編',
    isbn: '9786267782286',
    coverUrl:
      'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/8baf9be7-7c82-49df-aaee-83f7de9abd1a_compressed_9786267782286_3D_72dpi.webp',
    publishYear: 2026,
    category: '自然科學',
  },
];
